import { Component, OnInit, Injector } from '@angular/core';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'app-contextproject',
    templateUrl: './contextproject.component.html',
    styleUrls: ['./contextproject.component.css'],
    standalone: false
})

export class ContextProjectComponent extends PageBase implements OnInit {

  constructor(public ObjInjector: Injector)
  {
    super(ObjInjector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onReceiveLiterals() {}
}
